import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import MarineTrafficService from "Services/marine.traffic.service";

export const useShipmentTrackingHook = () => {
  /**
   * @param shipmentTrackingId - The ID used to fetch the shipment tracking data.
   * @param options - Optional dynamic callbacks for onSuccess and onError.
   * @returns A React Query result object.
   *
   * **Why:** Using dynamic callbacks allows consumers of the hook to define custom behavior for side effects after data fetching,
   * which makes the hook more reusable across different components.
   */
  const getShipmentTrackingById = (
    shipmentTrackingId: string,
    options?: UseQueryOptions<any, any>,
    type?: string
  ) => {
    return useQuery<any, any>(
      ["shipmentTracking", shipmentTrackingId, type],
      () => MarineTrafficService.status(shipmentTrackingId ?? "", type),
      {
        ...options,
      }
    );
  };

  const getFetchingDetailsShipmentTrackingById = (
    shipmentTrackingId: string,
    type?: string,
    options?: UseQueryOptions<any, any>
  ) => {
    return useQuery<any, any>(
      ["fetchingDetailsShipmentTracking", shipmentTrackingId, type],
      () => MarineTrafficService.statusFetchingDetails(shipmentTrackingId ?? "", type),
      {
        ...options,
      }
    );
  };

  return [{ getShipmentTrackingById, getFetchingDetailsShipmentTrackingById }];
};
